import React, { createContext, useContext, useEffect, useState } from 'react'
import LoaderCr from '../commons/Loader/LoaderCe';

interface LoaderContextProps {
    loading: boolean,
    showLoader: () => void,
    hideLoader: () => void,
}

interface LoaderProviderProps {
    children: React.ReactNode;
}

const LoaderContext = createContext<LoaderContextProps | undefined>(undefined); 

export const LoaderProvider: React.FC<LoaderProviderProps> = ({children})=> {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const handleTabPress = (event: KeyboardEvent) => {
          if (loading && event.key === 'Tab') {
            event.preventDefault();
          }
        };
      
        if (loading) {
          document.addEventListener('keydown', handleTabPress);
          document.body.style.overflow = "hidden";
        } else {
          document.removeEventListener('keydown', handleTabPress);
          document.body.style.overflow="visible";
        }
      
        return () => {
          document.removeEventListener('keydown', handleTabPress);
        };
      }, [loading]);

    const showLoader = ()=> {
        setLoading(true);
    }
    const hideLoader = () => {
        setLoading(false);
    }

    return (
        <LoaderContext.Provider value={{loading, showLoader, hideLoader}}>
            {children}
            <LoaderCr/>
        </LoaderContext.Provider>
    );
}

export const useLoader = (): LoaderContextProps => {
    const context = useContext(LoaderContext);
    if (!context) {
        throw new Error("useLoader must be used within a LoaderProvider");
    }
    return context;
}